<template>
  <el-card shadow="never" :body-style="{ padding: '10px' }">
    <Main
      ref="tableMain"
      :loading="loading"
      :tableData="tableData"
      @reload="() => $refs.tableHeader.query()"
    >
      <Header ref="tableHeader" slot="header" @query="getData" />
    </Main>
  </el-card>
</template>
<script>
import Main from './main'
import Header from './header'
export default {
  components: { Main, Header },
  props: {},
  data() {
    return {
      tableData: [],
      loading: false
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.tableData = []
      this.$api.reportTeamInputListDepApi({ ...form }).then((res) => {
        this.loading = false
        this.tableData = res.body.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
// .el-card__body {
//   padding: 10px !important;
// }
</style>
